import React, {Component, Fragment} from 'react';
import DatabaseContext from './context/DatabaseContext';
import AuthContext from './context/AuthContext';
import NavBar from './components/NavBar';
import Footer from "./components/Footer";
import config from "./fire-config";
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import Main from './visitors/components/Main';
import WorksPage from "./visitors/subscribers/works/WorksPage";
import BlogPage from "./visitors/subscribers/blog/BlogPage";
import About from "./visitors/components/About";
import Contact from "./visitors/publishers/Contact";
import {SingleArticle, SingleWork} from "./visitors/subscribers/SinglePost";
import Dashboard from "./admin/subscribers/Dashbord";

const firebase = require('firebase/app');
require('firebase/auth');
require('firebase/database');
firebase.initializeApp(config);

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rtd: firebase.database(),
            auth: firebase.auth(),
            googleProvider: new firebase.auth.GoogleAuthProvider(),
            currentUser: null
        };
    }

    componentDidMount() {
        const auth = this.state.auth;
        if (auth) {
            auth.onAuthStateChanged((user) => this.setState({currentUser: user}));
        }
    }

    render() {
        return (
            <BrowserRouter>
                <Fragment>
                    <div id="preloader"/>
                    <AuthContext.Provider
                        value={
                            {
                                currentUser: this.state.currentUser,
                                auth: this.state.auth,
                                googleProvider: this.state.googleProvider
                            }
                        }>
                        <DatabaseContext.Provider value={this.state.rtd}>
                            <NavBar/>
                            <main id="main">
                                <Switch>
                                    <Route exact path="/blog" component={BlogPage}/>
                                    <Route exact path="/portfolio" component={WorksPage}/>
                                    <Route exact path="/About" component={About}/>
                                    <Route exact path="/contact" component={Contact}/>
                                    <Route path="/blog/:id" component={SingleArticle}/>
                                    <Route path="/portfolio/:id" component={SingleWork}/>
                                    <Route path="/admin" component={Dashboard}/>
                                    <Route exact path="/" component={Main}/>
                                </Switch>
                            </main>
                            <Footer/>
                        </DatabaseContext.Provider>
                    </AuthContext.Provider>
                </Fragment>
            </BrowserRouter>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js